import styled from "styled-components";

export const Container = styled.div`
  background-color: rgba(255, 255, 255, 0.25);
  width: 100%;
  height: 2px;
  margin: 1rem 0;
  border-radius: 1rem;
`;
